import React, { useMemo } from "react";

function hasTechnicalQueryParam() {
  const params = new URLSearchParams(window.location.search);
  return params.has("technical-query");
}

export default function ContactFaqQueryIsland({ config }) {
  const links = useMemo(() => {
    if (hasTechnicalQueryParam()) {
      return {
        answerNoUrl: config.technicalAnswerNoUrl || config.defaultAnswerNoUrl || "/",
        backUrl: config.technicalBackUrl || config.defaultBackUrl || "/",
      };
    }

    return {
      answerNoUrl: config.defaultAnswerNoUrl || "/",
      backUrl: config.defaultBackUrl || "/",
    };
  }, [config]);

  return (
    <>
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <div className="row">
            <div className="col-md-6 mb-3">
              <a href={links.answerNoUrl} className="btn btn-lightest-blue">
                NO
              </a>
            </div>
            <div className="col-md-6 mb-3">
              <a href={config.yesUrl || "/"} className="btn btn-lightest-blue">
                YES
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-6 col-md-3 column mb-3 px-0">
          <a href={links.backUrl} className="btn btn-wide btn-arrow-left btn-back">
            <span>Back</span>
          </a>
        </div>
      </div>
    </>
  );
}
